import { Form } from "react-final-form";
import { onSubmit, onValidate } from "./FormManagementFormSubmit";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@emotion/react";
import { useEffect, useState } from "react";
import FormManagementFormStepOne from "./FormManagementFormSteps/FormManagementFormStepOne";

const FormManagementForm = (props) => {
  const theme = useTheme();
  const { step, setStep, update, initialValues: _initialValues } = props;
  const [initialValues, setInitialValues] = useState({});
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (update) {
      setInitialValues(_initialValues);
      return;
    }

    setInitialValues({
      documentType: "Przyjęcie",
      formManagementElements: [],
    });
    // eslint-disable-next-line
  }, []);

  return (
    <Form
      initialValues={initialValues}
      onSubmit={(val) => onSubmit(val, { ...props, setShowError })}
      validate={(val) => onValidate(val, { ...props, setShowError })}
      validateOnBlur={true}
    >
      {(formProps) => {
        return (
          <form
            id={props.formName}
            onSubmit={formProps.handleSubmit}
            className="CarForm"
          >
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={step}
              onChangeIndex={(index) => setStep(index)}
            >
              <FormManagementFormStepOne
                {...formProps}
                {...props}
                showError={showError}
              />
            </SwipeableViews>
          </form>
        );
      }}
    </Form>
  );
};

export default FormManagementForm;
